import { useLoaderData } from "react-router";
import { FeaturedRace } from "@rennpuls/components/races/featuredRace";
import { RaceCalendar } from "@rennpuls/components/races/raceCalendar";
import { NoFeaturedRace } from "@rennpuls/components/races/noFeaturedRace";
import { getFeaturedRace, getRacesForThisSeasonFromDate, getRecentCompletedRaces } from "@rennpuls/backend/domain/race/getFeaturedRace";
import {wrapLoader}  from "@/lib/wrap-loader";
import { getSession } from "@/app/session";

type LoaderData = Awaited<ReturnType<typeof getFeaturedRace>> extends infer F
    ? { featuredRace: F; racesForThisSeason: Awaited<ReturnType<typeof getRacesForThisSeasonFromDate>>; recentCompletedRaces: Awaited<ReturnType<typeof getRecentCompletedRaces>> }
    : never;

export const loader = wrapLoader(async ({ request }) => {
    const session = await getSession(request.headers.get("Cookie"));
    session.unset("registration");

    const featuredRace = await getFeaturedRace();
    const racesForThisSeason = await getRacesForThisSeasonFromDate();
    const recentCompletedRaces = await getRecentCompletedRaces(3); // Fetch last 3 completed races

    return { featuredRace, racesForThisSeason, recentCompletedRaces }
});

export default function Index() {
    const { featuredRace, racesForThisSeason, recentCompletedRaces } = useLoaderData<LoaderData>();

    return (
        <div>
            {featuredRace ? (
                <FeaturedRace race={featuredRace} recentRaces={recentCompletedRaces} />
            ) : (
                <NoFeaturedRace />
            )}
            <RaceCalendar races={racesForThisSeason} />
        </div>
    );
}
